
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recherche",
      function () {
        return require("private-next-pages/recherche.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recherche"])
      });
    }
  